// extracted by mini-css-extract-plugin
export default {"main":"title_main__s7DyP","transitionsItem":"title_transitionsItem__L92qb","container":"title_container__qrdDF"};